// import TaskList from "./TaskList";
import Header from './Header'
import Create from "./Create";
import {useState,lazy,Suspense} from 'react'
import Data from "./TaskData"
//React lazy loading code splitting
//Set the name of the component as a variable and then provide a callback function with lazy
const TaskList = lazy(() => import("./TaskList"))
const Tasks = () => {
    const[show ,setShow] = useState(false)
    const[tasks, setTasks]= useState(Data)
   
    const handleDelete= (id) => {
        const newBlogs= tasks.filter(task => task.id !== id)
        setTasks(newBlogs);
    }

    // const toggleReminder = (id) => {
    //     const newReminder= tasks.map((task) => task.id ===id ? {...task, reminder: !task.reminder} : task )
    //     setTasks(newReminder)
    // };
                //OR
    
    const toggleReminder = (id) => {
        setTasks((prevtask) => {
            return prevtask.map((task) => {
                return task.id === id ? {...task, reminder:!task.reminder} : task
            })
        })
    }

    const createTask = (task) => {
        console.log(task)
        const new_id = Math.floor(Math.random() * 1000) + 1
        const newTask = { new_id, ...task}
        setTasks([ ...tasks, newTask])
    }
    return (  
       <div className="task">
            <Header  onShow={() => setShow(!show)} showAdd= {show}/>
            {show && <Create onAdd ={createTask}/>}
            <Suspense fallback={<div>Loading...</div>}>
                {tasks.length > 0 ? <TaskList handleDelete={handleDelete} tasks={tasks} handleToggle={toggleReminder}/> : <h2>Add New Task</h2>}
            </Suspense>
       </div>
    );
}
export default Tasks;